import type { KeyValueStorage } from '@shootout-comps/core';

// Wraps localStorage in the async KeyValueStorage interface shared code expects.
const webStorage: KeyValueStorage = {
  getItem: (key: string) => Promise.resolve(localStorage.getItem(key)),
  setItem: (key: string, value: string) => {
    localStorage.setItem(key, value);
    return Promise.resolve();
  },
  removeItem: (key: string) => {
    localStorage.removeItem(key);
    return Promise.resolve();
  },
};

export default webStorage;
